/* eslint-disable prettier/prettier */
import React, { memo } from 'react';
import StatusImageItem from '@/pages/home/components/ImagesUploader/components/StatusImageItem';
import { noop } from '@/pages/home/utils/utils';
import { IStatusImageListProps } from '@/pages/home/components/ImagesUploader/types';
import SvgIcon from '@/pages/home/components/SvgIcon';

const StatusImageList: React.FC<IStatusImageListProps> = (props) => {
  const { imagesData, onDelete = noop, editImagesData, handleDeleteEditImage } = props;

  // 添加回显编辑上传图片功能，数据与新上传数据以及dom区分开来，需要分别处理
  const hasEditImage = Array.isArray(editImagesData) && editImagesData?.length > 0;

  return (
    <div className="unloadModal-showImg-flex">
      <>
        {hasEditImage && editImagesData?.map((imageSrc: string, index: number) =>
          <div className="unloadModal-showImg" key={index}>
            <img
              src={imageSrc}
              className="unloadModal-showImg-img"
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
            <i
              onClick={() => {
                handleDeleteEditImage?.(imageSrc);
              }}
            >
              <SvgIcon type="clonse" className="unloadModal-showImg-clonse" />
            </i>
          </div>
        )
        }
        {imagesData?.map((imageData) => (
          <StatusImageItem
            key={imageData?.uniqKey}
            {...imageData}
            src={imageData?.src}
            status={imageData?.status}
            progress={imageData?.progress}
            error={imageData?.error}
            errorMsg={imageData?.errorMsg}
            onDelete={onDelete}
          />
        ))}
      </>
    </div>
  );
};

export default memo(StatusImageList);
